import React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import BusinessIcon from '@mui/icons-material/Business';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import NotificationImportantIcon from '@mui/icons-material/NotificationImportant';
import FlagIcon from '@mui/icons-material/Flag';
import TextField from '@mui/material/TextField';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import Avatar from '@mui/material/Avatar';
import EstimateItem from './EstimateItem';
import ReassignPickupModal from '../Modals/ReassignPickupModal';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CircleIcon from '@mui/icons-material/Circle';

import {
    Card,CardContent,
    Button,
    Skeleton,
    Fab,
    Drawer,
    Slide,
    IconButton,
    InputLabel 
}
    from '@mui/material';
import UnscheduleReasonModal from '../Modals/UnscheduleReasonModal';
import PaymentModal from '../Modals/PaymentModal'
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';
import * as RetailStores from './RetailStores.js';
import Image from 'mui-image';
import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import StarIcon from '@mui/icons-material/Star';
import PaidIcon from '@mui/icons-material/Paid';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import dayjs from 'dayjs';
import AlertDialog from '../Modals/AlertDialog';
import ConfirmDialog from '../Modals/ConfirmDialog';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Scheduler from './Scheduler';
import RecycleFirstCompletion from './RecycleFirstCompletion';
import RecycleFirstPrompt from './RecycleFirstPrompt';

function PickupRequestDetail(props) {
    const [isFetching, setIsFetching] = React.useState(true);
    const [showScheduler, setShowScheduler] = React.useState(false);
    const [showRecycleFirstCompleted, setShowRecycleFirstCompleted] = React.useState(false);
    const [showPayment, setShowPayment] = React.useState(false);
    const [formErrors, setFormErrors] = React.useState({});
    const [order, setOrder] = React.useState(null);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [confirmUnschedule, setConfirmUnschedule] = React.useState(false);
    const [showDialog, setShowDialog] = React.useState('');
    const [flagOrderInput, setFlagOrderInput] = React.useState('');
    const [claimToken, setClaimToken] = React.useState(null);
    const genericInputRef = React.useRef(null);
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });
    const [isClaiming, setIsClaiming] = React.useState(false);

    const [alertDialog, setAlertDialog] = React.useState({
        show: false,
        title: '',
        message: '',
        closeButton: '',
    });

    const [confirmDialog, setConfirmDialog] = React.useState(null);

    //{
    //    close: null,
    //    title: '',
    //    cancelText: '',
    //    acceptText : '',
    //    content: '',
    //    data: ''
    //}


    React.useEffect(() => {
        if (order === null && props.PickupRequest !== null) {
            loadOrder(); 
        }
       
    });



    function loadOrder() {
        if (props.PickupRequest == null) {
            return;
        }
        setIsFetching(true);

        TokenService.post({ OrderGUID: props.PickupRequest.OrderGUID } , 'GetOrder')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    let pickupRequest = JSON.parse(jsonData.PickupRequest);
                    setOrder(pickupRequest);
                    setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="rectangular" sx={{ marginRight: 'auto', marginLeft: 'auto' }} height={'3px'} width={'90%'} />

            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="rectangular" sx={{ marginRight: 'auto', marginLeft: 'auto' }} height={'3px'} width={'90%'} />

            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="rectangular" sx={{ marginRight: 'auto', marginLeft: 'auto' }} height={'3px'} width={'90%'} />

            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="rectangular" sx={{ marginRight: 'auto', marginLeft: 'auto' }} height={'3px'} width={'90%'} />

            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'60%'} />
        </div>
    }

    function buildBusinessHours() {
        let hours = [];
        
        if (order.MonHours !== '') {
            let openHours = getHours(order.MonHours);
            hours.push(<tr key='MonHoursRow'><td>Mon </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.TueHours !== '') {
            let openHours = getHours(order.TueHours);
            hours.push(<tr key='TueHoursRow'><td>Tue </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.WedHours !== '') {
            let openHours = getHours(order.WedHours);
            hours.push(<tr key='WedHoursRow'><td>Wed </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.ThuHours !== '') {
            let openHours = getHours(order.ThuHours);
            hours.push(<tr key='ThuHoursRow'><td>Thu </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.FriHours !== '') {
            let openHours = getHours(order.FriHours);
            hours.push(<tr key='FriHoursRow'><td>Fri </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.SatHours !== '') {
            let openHours = getHours(order.SatHours);
            hours.push(<tr key='SatHoursRow'><td>Sat </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }
        if (order.SunHours !== '') {
            let openHours = getHours(order.SunHours);
            hours.push(<tr key='SunHoursRow'><td>Sun </td><td>{openHours.start.format("hh:mm A")} to {openHours.end.format("hh:mm A")}</td></tr>);
        }

        return (<table className='SummaryTable'>
            <tbody>
                <tr>
                    <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                </tr>

                <tr>
                    <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                        <AccessTimeIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} /> 
                        Business Hours
                    </td>
                </tr>
                {hours }
            </tbody>
            </table>
        );
    }

    function getHours(hourString) {
        let startHours = hourString.split(' to ')[0];
        let endHours = hourString.split(' to ')[1];
        let openingTime = dayjs().set('hour', parseInt(startHours.split(':')[0])).set('minute', parseInt(startHours.split(':')[1])).set('second', 0);
        let closingTime = dayjs().set('hour', parseInt(endHours.split(':')[0])).set('minute', parseInt(endHours.split(':')[1])).set('second', 0);
        return { start: openingTime, end: closingTime }

    }

    function closeConfirmDialog(didAccept) {
        
        if (didAccept) {
            let inputField = genericInputRef.current.querySelector('.MuiInputBase-input');
            if (inputField.value.trim().length > 0) {
                //

                TokenService.post({ orderGUID: props.PickupRequest.OrderGUID, Flagged: 'True', Flagged_Reason: inputField.value.trim() }, 'Returner_FlagOrder')
                    .then((response) => {
                        response = response[Object.keys(response)[0]];
                        if (response.Result == "SUCCESS") {
                            enqueueSnackbar('This order has  been flagged', {
                                variant: 'success',
                            });
                        }
                    })
                    .catch((response) => {
                        enqueueSnackbar('Oops, something went wrong', {
                            variant: 'error',
                        });
                    });
            }
        }
        setConfirmDialog(null);
    }

    function closeRecycleLaterDialog(didAccept, info) {

        if (didAccept) {

            TokenService.post({ orderGUID: props.PickupRequest.OrderGUID, reason: info.comments, photoData: info.photoData }, 'Returner_RequestRecyclerFirst')
                .then((response) => {
                    //response = response[Object.keys(response)[0]];
                    if (response.Result == "SUCCESS") {
                        let jsonData = JSON.parse(response.JsonData);
                        let updOrder = JSON.parse(jsonData.Order);
                        if (typeof updOrder === 'string') {
                            updOrder = JSON.parse(updOrder);
                        }
                        setOrder(updOrder);

                        setConfirmDialog({
                            show: true,
                            close: function () { setConfirmDialog(null) },
                            title: <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div>Recycle First Confirmed</div>
                                <Image wrapperStyle={{ width: '40px' }} src={'images/RecycleFirstIndicatorGreen.svg'} style={{ height: '40px', width: '40px' }} />
                            </div>,
                            acceptText: 'OK',
                            content: <div>
                                <div>We have notified the customer.</div>
                                <div style={{ marginTop: '10px' }}>Please complete the recycling in a timely manner and close out the order afterward.</div>
                                <div style={{ marginTop: '10px', fontWeight:'bold', color:'#cc0000' }}>You will need your bottle slips to close out the order.</div>
                            </div>,
                            data: ''
                        });
                    }
                })
                .catch((response) => {
                    enqueueSnackbar('Oops, something went wrong', {
                        variant: 'error',
                    });
                });


        }
        else {
            setConfirmDialog(null);
        }

        
    }

    function handleFlagOrderClicked() {
      
        setConfirmDialog({
            show:true,
            close: closeConfirmDialog,
            title: 'Flag this order?',
            cancelText: 'Cancel',
            acceptText : 'Flag it',
            content: <div>
                <div>Please let us know why you are flagging this order so a Sipzee team member can review and take appropriate action</div>
                <div style={{display:'flex', justifyContent:'center'} }>
                    <TextField multiline rows={4} ref={genericInputRef} variant="outlined" style={{ width: '300px' }} />
                </div>
                </div>,
            data: ''
        });
    }

    function closeAssignToOtherDialog(didAccept, recycler, selectedDate, selectedTime) {
        if (didAccept) {
            if (recycler == null || recycler == undefined) {
                enqueueSnackbar('You must select a recycler to re-assign this order', {
                    variant: 'error',
                });
            }
            else {
                let postData = {
                    orderGUID: props.PickupRequest.OrderGUID,
                    assignToEmail: recycler.EmailAddress,
                    selectedDate: selectedDate,
                    selectedTime: selectedTime
                }
                TokenService.adminServicePost(postData, 'Admin_ReassignOrder')
                    .then((response) => {
                        response = response[Object.keys(response)[0]];
                        if (response.Result == "SUCCESS") {
                            let jsonData = JSON.parse(response.JsonData);
                            let updOrder = JSON.parse(jsonData.Order);
                            if (typeof updOrder === 'string') {
                                updOrder = JSON.parse(updOrder);
                            }
                            setOrder(updOrder);
                            enqueueSnackbar('Order Reassigned to ' + updOrder.Owner + '.', {
                                variant: 'success',
                            });
                        }

                    })
                    .catch((response) => {
                        enqueueSnackbar('Oops, something went wrong', {
                            variant: 'error',
                        });
                    });
                setShowDialog(null);
            }
        }
        else {
            setShowDialog(null);
        }
    }

    function handleAssignToOther() {
        setShowDialog('Recycler Search');
    }

    

    function handleMoveBackToMarketplaceClicked() {
        setConfirmDialog({
            show: true,
            close: closeMoveBackToMarketplaceDialog,
            title: 'Move back to Marketplace?',
            cancelText: 'Cancel',
            acceptText: 'Proceed',
            content: <div>
                <div>This will silently Unschedule this request and re-send all returner notifications.</div>
            </div>,
            data: ''
        });
    }

    function closeMoveBackToMarketplaceDialog(didAccept) {

            if (didAccept) {
                

                TokenService.adminServicePost({ orderGUID: props.PickupRequest.OrderGUID}, 'Admin_MoveBackToMarketplace')
                        .then((response) => {
                            response = response[Object.keys(response)[0]];
                            if (response.Result == "SUCCESS") {
                                enqueueSnackbar('This order has been moved back to the marketplace', {
                                    variant: 'success',
                                });
                            }
                            let jsonData = JSON.parse(response.JsonData);
                            let updOrder = JSON.parse(jsonData.Order);
                            if (typeof updOrder === 'string') {
                                updOrder = JSON.parse(updOrder);
                            }
                            setOrder(updOrder);
                        })
                        .catch((response) => {
                            enqueueSnackbar('Oops, something went wrong', {
                                variant: 'error',
                            });
                        });
                
            }
            setConfirmDialog(null);
        
    }

   

    function copyRecyclerEmail(email) {
        navigator.clipboard.writeText(email);
        enqueueSnackbar(email + ' copied to clipboard', {
            variant: 'success',
        });
    }

    function buildStreetAddress() {
        if (order.Status_Reason == 'Unscheduled') {
            if (props.loggedInUser.CompletedOrders < 5) {
                let streetNumber = order.CustomerAddress_Street.replace(/\W[\W\w*\W]*/, "")
                return <><span style={{ filter: 'blur(3px)' }}>1234</span> {order.CustomerAddress_Street.replace(streetNumber, "")} </>
            }
        }

        return order.CustomerAddress_Street;
    }

    function handleAttemptToClaim() {
        setIsClaiming(true);
        TokenService.post({ orderGUID: props.PickupRequest.OrderGUID}, 'Returner_AttemptToClaim')
        .then((response) => {
            setIsClaiming(false);
            //response = response[Object.keys(response)[0]];
            if (response.Result == "SUCCESS") {
                let data = JSON.parse(response.JsonData);
                if (typeof data.ClaimToken === 'string') {
                    data.ClaimToken = JSON.parse(data.ClaimToken);
                }
                setClaimToken(data.ClaimToken);
                handleShowScheduler();
            }
            else {
                enqueueSnackbar(response.Message, {
                    variant: 'error',
                });    
            }
        })
        .catch((response) => {
            setIsClaiming(false);
            enqueueSnackbar('Oops, something went wrong', {
                variant: 'error',
            });
        });
    }

    function buildOrder() {
        
        if (order === null) {
            return null;
        }

        if (order.Owner.toLowerCase() !== props.loggedInUser.EmailAddress.toLowerCase() && order.Owner !== 'In Process' && props.viewType !== 'admin') {
            return <div>This order has already been claimed by someone else.</div>
        }

        let availDate = (dayjs(order.CustomerDateAvailableForPickup.Data));
        let selectedStores = RetailStores.getStoreIcons(order);
        let containerDetails = order.Returnable_Type_Container_Detail_JSON;
        if (containerDetails !== '') {
            containerDetails = JSON.parse(containerDetails);
        }
        return (
            <>
                <div style={{ fontSize: '10pt', position: 'relative', right: 0, top: 0 }}>
                    <div style={{ fontSize: '10pt', position: 'absolute', right: 0, top: -40 }}>
                        <Fab size='small' onClick={() => handleFlagOrderClicked() }><FlagIcon sx={{ fontSize: 30, color: 'var(--sipzee-red)' }} /></Fab>
                        <div>Flag order</div>
                    </div>
                </div>
                <table className='SummaryTable'>
                    <tbody>
                        <tr>
                        
                            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                <div style={{display:'flex', justifyContent:'space-between'} }>
                                    <SentimentSatisfiedAltIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{alignSelf:'center'} }/>
                                    <span style={{ alignSelf: 'center' }}>Customer</span> 
                                   <span></span>
                                </div>

                            </td>
                        </tr>
                        <tr>
                            <td>Name:</td>
                            <td>{order.CustomerName}</td>
                        </tr>
                        <tr>
                            <td>Date Available:</td>
                            <td>{availDate.format('ddd MMM DD')}</td>
                        </tr>
                        {
                            order.Status_Reason !== 'Scheduled' ? null :
                                <tr>
                                    <td>Call Customer</td>
                                    <td>Phone</td>
                                </tr>

                        }
                        <tr>
                            <td>
                                Status:
                            </td>
                            <td>
                                {order.Status}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Status Reason:
                            </td>
                            <td>
                                {order.Status_Reason}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Pickup Type:
                            </td>
                            <td>
                                {order.PickupType}
                            </td>
                        </tr>
                        {order.PickupType == 'Continuous' &&
                            <tr>
                                <td colsPan='2' style={{textAlign:'left', fontWeight:'normal', paddingLeft:'10px', paddingRight:'10px'}}>
                                        <div style={{height:'3px', backgroundColor:'var(--sipzee-gray-2)'}}></div>
                                        <div><CircleIcon sx={{height:'12px'}} /> Continuous pickups are typically extra large.</div>
                                        <div><CircleIcon sx={{height:'12px'}} /> You can take as many as you want.</div>
                                        <div><CircleIcon sx={{height:'12px'}} /> You will use the Recycle First option.</div>
                                        <div><CircleIcon sx={{height:'12px'}} /> Payment is based on the final quantity collected.</div>
                                      
                                        <div style={{height:'3px', backgroundColor:'var(--sipzee-gray-2)'}}></div>
                                    </td>
                            </tr>
                        }
                        {props.viewType === 'admin' && order.Owner !== 'In Process' ? 
                            
                            <>
                            <tr>
                                <td>
                                    Recycler:
                                </td>
                                <td>
                                        {order.Owner_FirstName}<br />
                                       
                                    </td>

                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        {order.Owner} <Fab size={'small'} onClick={() => { copyRecyclerEmail(order.Owner) }}><ContentCopyIcon /></Fab>
                                    </td>
                                </tr>
                       
                            <tr>
                                    <td>
                                        Recycler Photo:
                                    </td>
                                    <td>
                                        <Avatar src={order.Status_Reason == 'Unscheduled' ? '/images/ProfileImage.png' :
                                            (order.Owner_ImagePath.indexOf('sipzeephotos.blob.core') > -1 ? order.Owner_ImagePath : 'https://sipzee.com/Returner/ReturnerProfilePics/' + order.Owner_ImagePath)
                                        } sx={{ width: 75, height: 75 }} />

                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Scheduled Pick Up:
                                    </td>
                                    <td>
                                        {order.Status_Reason === 'Scheduled' ?
                                            <div style={{ marginTop: '20px', marginBottom: '20px' }} >{order.ScheduledPickUpDate} between {order.EstPickUpWindow.replace("_", "-")}
                                            </div>
                                            :
                                            order.ScheduledPickUpDate}
                                    </td>
                                </tr>
                            </>
                            :
                            null
                        }
                    </tbody>
                </table>
                {props.loggedInUser.UserAccess.includes('ADMIN') === false ? null :
                    <table className='SummaryTable'>
                        <tbody>
                            <tr>
                                <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                            </tr>
                            <tr>
                                <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                   Admin
                                </td>
                            </tr>
                            <tr>
                                <td colSpan='2' >
                                    <Button variant='outlined' style={{}} sx={{ backgroundColor: 'var(--sipzee-red-2)', marginTop: '10px' }} onClick={() => handleMoveBackToMarketplaceClicked()}>Back to Market</Button>
                                    <Button variant='outlined' style={{}} sx={{ backgroundColor: 'var(--sipzee-red-2)', marginTop: '10px', marginLeft: '5px' }} onClick={() => handleAssignToOther()}>Assign to...</Button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    }
                <table className='SummaryTable'>
                    <tbody>
                        <tr>
                            <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                        </tr>

                        <tr>
                            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                {order.LocationType === 'Residence' ?
                                    <HomeIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} /> : <BusinessIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 30 }} style={{ position: 'absolute', left: '0px' }} />
                                }
                                Address
                            </td>
                        </tr>
                        <tr>
                            <td>

                                Street:
                            </td>
                            <td>{buildStreetAddress()}</td>
                        </tr>
                        {order.CustomerAddress_Apt_Suit_Other === '' ? null :
                            <tr>
                                <td>Apt/Suite:</td>
                                <td>{order.CustomerAddress_Apt_Suit_Other}</td>
                            </tr>
                        }

                        <tr>
                            <td>City:</td>
                            <td>{order.CustomerAddress_City}</td>
                        </tr>
                        <tr>
                            <td>State:</td>
                            <td>{order.CustomerAddress_State}</td>
                        </tr>
                        <tr>
                            <td>Zip:</td>
                            <td>{order.CustomerAddress_Zipcode}</td>
                        </tr>
                    </tbody>
                </table>
                {
                    order.LocationType !== 'Business' ? null :
                    buildBusinessHours()

                }
                <table className='SummaryTable SummaryFinancials'>
                    <tbody>
                        <tr>
                            <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                        </tr>

                        <tr>
                            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                <Image src='images/payout.png' style={{ height: 'auto', width: '40px', position: 'absolute', left: '5px', top: '2px' }} />
                                Financials
                            </td>
                        </tr>
                            {order.BottleSlipTotalQuantity > 0 ?
                            <>
                                <tr>
                                    <td>Actual Quantity:</td>
                                    <td style={{ fontWeight: 'bold' }}>{order.BottleSlipTotalQuantity}</td>
                                </tr>
                                <tr>
                                    <td>Bottle slips uploaded: </td>
                                    <td>{ order.BottleSlipCount }</td>
                                </tr>

                                {(order.TipAmount === '' || order.TipAmount === '0')
                                    ?
                                    <tr style={{ color: 'var(--sipzee-red)' }}>
                                        <td><Fab style={{ marginRight: '15px' }} onClick={() => showMoreInfo('PurchaseCost')}>
                                            <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                                        </Fab> <span>{props.viewType === 'admin' ? '' : 'Your '}Purchase Cost</span>:</td>
                                        <td><span>{formatter.format(order.RecyclerPurchaseCost)}</span></td>
                                    </tr>
                                    :
                                    <>
                                        <tr>
                                            <td>Purchase Cost:</td>
                                            <td>{formatter.format(order.RecyclerPurchaseCost + parseFloat(order.TipAmount))}</td>
                                        </tr>
                                        <tr>
                                            <td>Tip Amount:</td>
                                            <td>({formatter.format(order.TipAmount)})</td>
                                        </tr>
                                        <tr style={{ color: 'var(--sipzee-red)' }}>
                                            <td> <Fab style={{ marginRight: '15px' }} onClick={() => showMoreInfo('PurchaseCost')}>
                                                <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                                            </Fab> <span>{props.viewType === 'admin' ? '' : 'Your '} Purchase Cost:</span></td>
                                            <td>
                                                <span>{formatter.format(order.RecyclerPurchaseCost)}</span>
                                            </td>
                                        </tr>

                                       
                                    </>
                                }

                                <tr style={{ color: 'var(--sipzee-green)' }}>
                                    <td>Profit:</td>
                                    <td><span style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>{formatter.format((order.BottleSlipTotalQuantity * .1) - order.RecyclerPurchaseCost)}</span></td>
                                </tr>
                            </>
                            :
                            <>
                                <tr>
                                    <td>Estimated Quantity:</td>
                                    <td style={{ fontWeight: 'bold' }}>{order.Quantity_Of_Cans_Bottles}</td>
                                </tr>
                                <tr>
                                    <td>Estimated bottle value:</td>
                                    <td>
                                        {order.PickupType == 'On Demand' ? 
                                            formatter.format(order.Quantity_Of_Cans_Bottles * .1)
                                        :
                                            <>Depends on the amount picked up.</>
                                        }   
                                    </td>
                                </tr>
                                {(order.TipAmount === '' || order.TipAmount === '0')
                                    ?
                                    <tr style={{ color: 'var(--sipzee-red)' }}>
                                        <td><Fab style={{ marginRight: '15px' }} onClick={() => showMoreInfo('PurchaseCost')}>
                                            <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                                        </Fab> <span>{props.viewType === 'admin' ? '' : 'Your '}Purchase Cost</span>:</td>
                                        <td>
                                            <span>
                                                {order.PickupType == 'On Demand' ? 
                                                formatter.format(order.RecyclerPurchaseCost)
                                                :
                                                    <>Depends on the amount picked up.</>
                                                }  
                                            </span>
                                        </td>
                                    </tr>
                                    :
                                    <>
                                        <tr>
                                            <td>Purchase Cost:</td>
                                            <td>
                                                {order.PickupType == 'On Demand' ?
                                                    formatter.format(order.RecyclerPurchaseCost + parseFloat(order.TipAmount))
                                                    :
                                                    <>Depends on the amount picked up.</>
                                                }  
                                           </td>
                                        </tr>
                                        <tr>
                                            <td>Tip Amount:</td>
                                            <td>({formatter.format(order.TipAmount)})</td>
                                        </tr>
                                        <tr style={{ color: 'var(--sipzee-red)' }}>
                                            <td> <Fab style={{ marginRight: '15px' }} onClick={() => showMoreInfo('PurchaseCost')}>
                                                <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 40 }} />
                                            </Fab> <span>{props.viewType === 'admin' ? '' : 'Your '} Purchase Cost:</span></td>
                                            <td>
                                                <span>
                                                    {order.PickupType == 'On Demand' ?
                                                        formatter.format(order.RecyclerPurchaseCost)
                                                        :
                                                        <>Depends on the amount picked up.</>
                                                    }
                                                </span>
                                            </td>
                                        </tr>
                                    </>
                                }

                                <tr style={{ color: 'var(--sipzee-green)' }}>
                                    <td>Estimated Profit:</td>
                                    <td>
                                        {order.PickupType == 'On Demand' ?
                                            <span style={{ borderTop: '1px solid black', fontWeight: 'bold' }}>
                                                {formatter.format((order.Quantity_Of_Cans_Bottles * .1) - order.RecyclerPurchaseCost)}
                                            </span>
                                            :
                                            <>Depends on the amount picked up.</>
                                        }
                                    </td>
                                </tr>
                            </>
                        }
                       
                       
                       
                    </tbody>
                </table>
                <table className='SummaryTable'>
                    <tbody>
                        <tr>
                            <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                        </tr>

                        <tr>
                            <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                Additional Info
                            </td>
                        </tr>
                        {order.CustomerSpecialInstructions === '' ? null :
                            <tr>
                                <td>Special Instructions:</td>
                                <td>{order.CustomerSpecialInstructions}</td>
                            </tr>
                        }
                        {selectedStores.length === 0 ?
                            null :
                            <>
                                <tr >
                                    <td colSpan='2' style={{ fontWeight: 'normal' }}>The customer indicated their bottles and cans mostly came from:</td>
                            </tr>
                            <tr>
                                <td colSpan='2'>
                                <div style={{ alignSelf: 'flex-start', display: 'flex', justifyContent: 'flex-start', width: '100%', minHeight: '35px' }}>
                                    {selectedStores}
                                    </div>
                                </td>
                            </tr>
                            </>
                        }
                    </tbody>
                </table>
                {containerDetails == '' ?
                    null :
                    <table className='SummaryTable'>
                        <tbody>
                            <tr>
                                <td colSpan='2'><div className={'SummaryTableDivider'}> </div></td>
                            </tr>

                            <tr>
                                <td colSpan='2' className='SummaryTableSectionHeader' style={{ textAlign: 'center' }}>
                                    Estimated Quantities
                                </td>
                            </tr>
                            <tr>
                                <td colSpan='2' style={{ textAlign: 'center' }} >
                                    {containerDetails.map((container, containerIndex) => (
                                        <EstimateItem container={container} />
                                    ))}
                                </td>
                            </tr>
                        
                        </tbody>
                    </table>
                }
                {order.CustomerPhotoDataBase64String === '' ?
                    null :
                    <table className='SummaryTable'>
                        <tbody>
                            {order.CustomerPhotoDataBase64String === '' ?
                                null
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }} >
                                        <img src={order.CustomerPhotoDataBase64String} style={{maxWidth:'300px'} } />
                                    </td>
                                </tr>
                            }
                            {order.CustomerPhotoDataBase64String2 === '' ?
                                null
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }}>
                                        <img src={order.CustomerPhotoDataBase64String2} style={{ maxWidth: '300px' }} />
                                    </td>
                                </tr>
                            }
                            {order.CustomerPhotoDataBase64String3 === '' ?
                                null
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }}>
                                        <img src={order.CustomerPhotoDataBase64String3} style={{ maxWidth: '300px' }} />
                                    </td>
                                </tr>
                            }
                            {order.CustomerPhotoDataBase64String4 === '' ?
                                null
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }}>
                                        <img src={order.CustomerPhotoDataBase64String4} style={{ maxWidth: '300px' }} />
                                    </td>
                                </tr>
                            }
                            {order.CustomerPhotoDataBase64String5 === '' ?
                                null
                                :
                                <tr>
                                    <td colSpan='2' style={{ textAlign: 'center' }}>
                                        <img src={order.CustomerPhotoDataBase64String5} style={{ maxWidth: '300px' }} />
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
                <div style={{ marginTop: '20px', marginBottom: '10px' }}>
                    {props.viewType !== 'admin' && order.Status_Reason === 'Unscheduled' && order.RecyclerRequestedByCustomerTimestampUTC.Data != '' && order.Owner.toLowerCase() == props.loggedInUser.EmailAddress.toLowerCase() ?
                        <>
                            <Button variant='outlined' sx={{ backgroundColor: 'var(--sipzee-red-2)' }} style={{ marginRight: '10px' }} onClick={() => handleDelineCustomerRequestedRecycler()}>Decline</Button>
                            <Button variant='outlined' sx={{ backgroundColor: 'var(--sipzee-green)' }} style={{ marginLeft: '10px' }} onClick={() => handleShowScheduler()}>Accept</Button>
                        </>
                        :
                        props.viewType !== 'admin' && order.Status_Reason === 'Unscheduled' ?
                            <Button disabled={isClaiming} variant='outlined' sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={() => handleAttemptToClaim()}>{isClaiming ? 'Claiming' : 'Claim'}</Button>
                        : null
                    }

                    {
                        //   && (props.loggedInUser.CompletedOrders >= 10 || parseInt(order.Quantity_Of_Cans_Bottles) > 1000 || props.loggedInUser.EmailAddress.toLowerCase() == 'jason.hornor@sipzee.com') &&

                        props.viewType !== 'admin' && order.Status_Reason === 'Scheduled' && order.Owner.toLowerCase() == props.loggedInUser.EmailAddress.toLowerCase()
                            && (props.loggedInUser.Abilities.RecycleFirst) &&
                        (order.RecycleFirstTimestampUTC.Data == null) ?
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom:'10px' }}>
                                <Button variant='outlined' style={{ maxWidth: '110px' }} sx={{ backgroundColor: 'var(--sipzee-yellow)' }} onClick={() => showRecycleFirstPrompt()}>Recycle First  <Image wrapperStyle={{ width: '30px' }} src={'images/RecycleFirstIndicatorGreen.svg'} style={{ height: '30px', width: '30px' }} /></Button>
                            </div>
                            :
                            null
                    }


                    {props.viewType !== 'admin' && order.Status_Reason === 'Scheduled' && order.Owner.toLowerCase() == props.loggedInUser.EmailAddress.toLowerCase() ?
                      
                        <div style={{display:'flex', justifyContent:'space-between'} }>
                            <Button variant='outlined' style={{ maxWidth: '110px' }} sx={{ backgroundColor: 'var(--sipzee-red-2)' }} onClick={() => setConfirmUnschedule(true)}>Unschedule</Button>
                            <Button variant='outlined' style={{ maxWidth: '110px' }} sx={{ backgroundColor: 'var(--sipzee-yellow)' }} onClick={() => setShowScheduler(true)}>Reschedule</Button>
                            {
                                
                                order.RecycleFirstTimestampUTC.Data == null && order.MustRecycleFirst == false ?
                                    <Button variant='outlined' style={{ maxWidth: '110px' }} sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={() => setShowPayment(true)}>Purchase</Button>
                                    :
                                    order.RecycleFirstTimestampUTC.Data != null ?
                                        <Button variant='outlined' style={{ maxWidth: '110px' }} sx={{ backgroundColor: 'var(--sipzee-green)' }} onClick={() => setShowRecycleFirstCompleted(true)}>Recycling Complete</Button>
                                    : null
                            }
                           
                            </div>
                        : null
                    }
                    {props.viewType === 'admin' ?

                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            {order.Status_Reason === 'Scheduled' ?
                                <Button variant='outlined' style={{}} sx={{ backgroundColor: 'var(--sipzee-red-2)' }} onClick={() => handleMoveBackToMarketplaceClicked()}>Back to Market</Button>
                                : null
                            }
                            <Button variant='outlined' style={{ maxWidth: '110px' }} sx={{ backgroundColor: 'var(--sipzee-green-2)' }} target='_blank' href={'/Order/?Order=' + order.OrderGUID }>View</Button>
                        </div>
                        : null
                    }
                </div>
            </>    
        )
    }

    function showMoreInfo(infoType) {
        if (infoType == 'PurchaseCost') {
            setAlertDialog({
                show: true,
                title: '',
                message:
                    <div style={{ display: 'flex' }}>
                        <HelpOutlineIcon sx={{ color: 'var(--sipzee-yellow)', fontSize: 50 }} style={{ alignSelf: 'center' }} />
                        <div style={{ marginLeft: '15px', marginRight: '15px' }}>
                            <div style={{ marginTop: '10px', fontSize: '16pt', fontWeight: 'bold' }}>Purchase Cost</div>
                            <div style={{ marginTop: '10px' }}>The cost to purchase this order is {formatter.format(order.RecyclerPurchaseCost)}</div>
                            <div style={{ marginTop: '10px', fontWeight:'bold'}}>All transactions are done using Sipzee</div>
                            <div style={{ marginTop: '10px' }}>Once you arrive at the customer address, log back into Sipzee, open this order in My Open Orders, and select Purchase.</div>
                          
                        </div>
                    </div>,
                closeButton: 'Ok',
            });
        }
      

    }

    function handleOnBack()
    {

        setOrder(null);
        props.onBack();
    }

    function handleShowScheduler() {
        setShowScheduler(true);
    }

    function handleDelineCustomerRequestedRecycler() {
        setConfirmDialog({
            show: true,
            close: closeDeclineCustomerRequestDialog,
            title: 'Decline this order?',
            cancelText: 'No',
            acceptText: 'Yes',
            content: <div>
                <div style={{fontWeight:'bold'} }>Do you want to decline this order?</div>
                <div style={{ marginTop: '10px' }}>This will move the order back to the Marketplace so another recycler can claim it.</div>
                <div style={{marginTop:'10px'} }>The customer will not be notified until another recycler schedules it.</div>
            </div>,
            data: ''
        });
    }

    function closeDeclineCustomerRequestDialog(didAccept) {
        if (didAccept) {
            props.onDeclined(props.PickupRequest);
        }

        setConfirmDialog(null);
    }

    function showRecycleFirstPrompt() {
        setConfirmDialog({
            show: true,
            close: closeRecycleLaterDialog,
            title: 'Recycle Before Purchase?',
            content: <RecycleFirstPrompt onClose={closeRecycleLaterDialog} />,
            data: ''
        });
    }

    function buildScheduler() {
        
        return (<Drawer anchor='bottom' open={showScheduler} style={{ height: '90vh' , width: '100%' }}>
            <Scheduler PickupRequest={props.PickupRequest} onClose={() => setShowScheduler(false)} onScheduled={props.onScheduled} claimToken={claimToken} />
        </Drawer>)
    }


    function buildRecycleFirstCompleted() {

        return (<Drawer anchor='bottom' open={showRecycleFirstCompleted} style={{ height: '90vh', width: '100%' }}>
            <RecycleFirstCompletion OnPickupRequestChanged={(pickupRequest) => setOrder(pickupRequest)} PickupRequest={order} onClose={() => setShowRecycleFirstCompleted(false)} onPayment={() => setShowPayment(true)} />
        </Drawer>)
    }



    function handleOrderUnscheduleAccepted(reason) {
        setConfirmUnschedule(false);

        props.onUnscheduled(props.PickupRequest, reason);
       
    }

    function handlePaymentCompleted(pickupRequest, paypalDetails) {
        props.onPaymentCompleted(pickupRequest, paypalDetails);
    }

    return (
        <div componentname='PickupRequestDetail'>

            <div style={{ display: 'flex' }}>
                {props.onBack == null ? null :
                    <Button variant='outlined' onClick={() => handleOnBack()}> <ArrowBackIosIcon />Back</Button>
                }
            </div>
            {isFetching ? buildSkeleton() 
                :
                buildOrder()
            }

     
            {buildScheduler()}

            {buildRecycleFirstCompleted()}

            <AlertDialog isShown={alertDialog.show} close={() => setAlertDialog({ show: false })} Title={alertDialog.title} Message={alertDialog.message} CloseText={alertDialog.closeButton} />

            {
                confirmDialog !== null ?
                    <ConfirmDialog Close={confirmDialog.close} Title={confirmDialog.title} Content={confirmDialog.content} CancelText={confirmDialog.cancelText} AcceptText={confirmDialog.acceptText} Data={confirmDialog.data} />
                    : null
            }

            {
                confirmUnschedule ? 
                    <UnscheduleReasonModal Close={(e) => setConfirmUnschedule(false)} OnAccept={(reason) => handleOrderUnscheduleAccepted(reason) }  />
                    : null
            }

            {showPayment ?
                <PaymentModal PickupRequest={order} Close={(e) => setShowPayment(false)} onPaymentCompleted={(pickupRequest, paypalDetails) => { handlePaymentCompleted(pickupRequest, paypalDetails) } } />
                : null
            }


            {showDialog === 'Recycler Search' ?
                <ReassignPickupModal Order={order} onClose={closeAssignToOtherDialog} />
                : null
            }
        </div>    
    )
    
    
}

export default PickupRequestDetail;